<template>
  <section class="audio">
    <audio
      controls
      :src="config.attrs.src">
        {{$t('content.notSupportAudio')}}
      <code>{{$t('content.audio')}}</code> {{$t('content.element')}}.
    </audio>
    <p class="description" v-if="config.attrs.description">
      {{ config.attrs.description }}
    </p>
  </section>
</template>

<script>
export default {
  components: {},
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {},
  mounted(){
  }
};
</script>

<style lang="scss" scoped>
.audio {
  audio {
    display: block;
    width: 100%;
  }
}
</style>